import register from '@kpsys/angularjs-register';
import CurrentAuthProvider from './current-auth.provider';
import CurrentDepartmentProvider from './current-department.provider';
import LocalizationServiceProvider from './localization.provider';
import {CurrentLanguageProvider} from './current-language.provider';

export default register('portaro.providers')
    .provider(CurrentAuthProvider.providerName, CurrentAuthProvider)
    .provider(CurrentDepartmentProvider.providerName, CurrentDepartmentProvider)
    .provider(LocalizationServiceProvider.providerName, LocalizationServiceProvider)
    .provider(CurrentLanguageProvider.providerName, CurrentLanguageProvider)
    .name();
